import get from 'lodash/get';

// function that takes in the component config for a QueryParamSection and the queryParams active on the current page
// and verifies whether or not this component is currently rendered so that we know whether or not to load / fetch data
export const queryParamSectionShouldLoad = (componentConfig, queryParams) => {
  const queryToWatch = get(componentConfig, 'props.queryToWatch');
  const requiredQueryValue = get(
    componentConfig,
    'props.requiredQueryValue',
    ''
  );
  return get(queryParams, queryToWatch, '') === requiredQueryValue;
};
